module.exports = __webpack_public_path__ + "static/media/perspective-dice-six.8b7e2589.svg";